import {getAllTerminalsByLocalId} from '../../../../../../../../crud/management_api/terminals';


export interface TerminalOption {
  id: number | string;
  name: string;
}
let _terminalOptionsCache: TerminalOption[] | null = null;


export const getTerminalOptions = async (): Promise<TerminalOption[]> => {
  if (_terminalOptionsCache) {
    return _terminalOptionsCache;
  }

  const userContext = localStorage.getItem('user');
  const localId = userContext ? JSON.parse(userContext).local_id : 0;

  const response = await getAllTerminalsByLocalId(localId);
  const data = response?.data || [];

  const terminals = data.map((t: any) => ({
    id: t.terminal_id,
    name: t.terminal_name
  }));

  _terminalOptionsCache = [ {id: "", name:"Ninguna"},...terminals];
  return _terminalOptionsCache;
};
